if(!customElements.get('member-cart-upsell')) {
  class ComponentMemberCartUpsell extends HTMLElement {
    constructor() {
      super();

      const btn = this.querySelector('.drawer-upsell-button');

      btn.addEventListener('click', async (event) => {
        if (!btn || btn.disabled) return;

        const variantId = parseInt(btn.dataset.membershipVariant);
        const sellingPlanId = parseInt(btn.dataset.membershipSellingPlan);
        const giftId = parseInt(btn.dataset.giftId);
        var payload = {
          items: [{
            id: variantId,
            quantity: 1
          }]
        };

        if(giftId && giftId != ''){
          payload.items.push({
            id: giftId,
            quantity: 1
          })
        }


        if (!isNaN(sellingPlanId)) {
          payload.items[0].selling_plan = sellingPlanId;
        }

        btn.disabled = true;
        const originalText = btn.textContent;
        btn.textContent = 'Adding...';

        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify(payload)
          });

          if (!res.ok) throw new Error('Cart add failed');

          const cart = await fetch('/cart.js').then(r => r.json());
          const exists = cart.items.find(item => item.variant_id === variantId);
          if (!exists) throw new Error('Membership not found in cart');

          window.location.reload();
          

        } catch (err) {
          console.error('[Membership Upsell Error]', err);
          btn.textContent = 'Error';
          alert('Could not add membership.');
        }

        setTimeout(() => {
          btn.textContent = originalText;
          btn.disabled = false;
        }, 2000);
      });


   

    }



  }
  customElements.define('member-cart-upsell', ComponentMemberCartUpsell);
}